import React from "react";
import StoryQuery from "components/pages/article/StoryQuery";
import RedeemShareSection from "components/pages/article/RedeemShareSection";
import ApiUser from "models/data/api/ApiUser";
import ApiStory from "models/data/api/ApiStory";
import TextEssay from "components/pages/article/TextEssay";
import { getStoryId } from "data/api/ApiStory";
import { isEmpty } from "lodash";
import { SearchPage } from "components/pages/SearchPage";
import { useRecordPaywallViewed } from "hooks/analytics/useRecordPaywallViewed";
import { useUserContext } from "contexts/new/UserContext";
import { useArticlePageContext } from "contexts/new/ArticlePageContext";
import { useRoutingContext } from "contexts/new/RoutingContext";

interface _StoryContentProps {
  sharedStoryLinkExists: boolean;
  story;
  sharedStoryLinkId: string;
  user;
}

const _StoryContent = ({
  sharedStoryLinkExists,
  story,
  sharedStoryLinkId,
  user,
}: _StoryContentProps) => {
  const storyId = getStoryId(story);

  if (isEmpty(story)) return <div />;

  const userContext = useUserContext();
  const articlePageContext = useArticlePageContext();
  const routingContext = useRoutingContext();

  const userAndArticleLoaded =
    userContext.initialized && articlePageContext.initialized;
  const paywallShown = !userContext.userIsSubscriber && !sharedStoryLinkExists;

  const paywalled = paywallShown && userAndArticleLoaded;

  useRecordPaywallViewed({
    userContext,
    articlePageContext,
    routingContext,
    paywalled,
  });

  const Essay = () => (
    <TextEssay
      story={story}
      paywalled={paywalled}
      sharedStoryLinkExists={sharedStoryLinkExists}
    />
  );

  return (
    <>
      <RedeemShareSection
        story={story}
        paywalled={paywalled}
        storyId={storyId}
        sharedStoryLinkId={sharedStoryLinkId}
        currentUserIsNotSubscribed={ApiUser.subscriptionHasExpired(user)}
      />
      {ApiStory.hasEssay(story) ? <Essay /> : <SearchPage errorPage={true} />}
    </>
  );
};

interface StoryContentProps {
  sharedStoryLinkId: string;
  storySlug: string;
}

const StoryContent = ({
  storySlug,
  sharedStoryLinkId,
}: StoryContentProps): JSX.Element => {
  return (
    <StoryQuery storySlug={storySlug} sharedStoryLinkId={sharedStoryLinkId}>
      {({ sharedStoryLinkExists, story, user }) => (
        <>
          <_StoryContent
            user={user}
            story={story}
            sharedStoryLinkId={sharedStoryLinkId}
            sharedStoryLinkExists={sharedStoryLinkExists}
          />
        </>
      )}
    </StoryQuery>
  );
};

export default StoryContent;
